import React, { ChangeEvent, SetStateAction } from 'react'
import { useGMapInput } from './hooks/useGMapInput'
import { CargoItemInterface, PointItemInterface } from '../../../../../types/interfaces'
import classes from './GMapInput.module.sass'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../../store/slices/settingsSlice'

type Props = {
  fieldName: 'city' | 'address'
  setData: React.Dispatch<SetStateAction<PointItemInterface[]>>
  data: PointItemInterface[]
  el: PointItemInterface
  index: number
  placeHolder: string
  addresses: boolean
  intercity: boolean
  topData: CargoItemInterface
  setTopData: React.Dispatch<SetStateAction<CargoItemInterface>>
}

export const GMapInput = ({
  fieldName,
  setData,
  data,
  el,
  index,
  placeHolder,
  addresses,
  intercity,
  topData,
  setTopData,
}: Props) => {
  const { dataReset } = useGMapInput(
    fieldName,
    setData,
    data,
    el,
    index,
    intercity,
    addresses,
    topData,
    setTopData,
  )

const darkTheme = useSelector(selectDarkTheme)

  return (
    <input
      className={darkTheme ? classes.InputDark : classes.Input}
      id={`${fieldName}_${el.id}`}
      name={fieldName}
      defaultValue={el[fieldName].value}
      placeholder={placeHolder}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        dataReset(e)
      }}
      onBlur={() => {
        let tempData = [...data]
        tempData[index][fieldName].isDirty = true
        setData(tempData)
      }}
      // style={{
      //   borderLeft: el.city.isEmptyError ? ' solid 1px rgb(254, 111, 103,0.8)' : '',
      // }}
    />
  )
}
